// 售后列表
<template>
  <div class="sld_after_connection_bill">
    <MemberTitle style="padding-left: 20px" memberTitle_two="客户账单"></MemberTitle>
    <div class="after_sales_list_main">
      <div class="flex_row_between_center">
        <div class="sld_order_nav_con flex_row_start_center pointer sld_order_tag">
          <div :class="{ item: true, active: current_state == '' }" @click="changeState('')">全部</div>
          <div :class="{ item: true, active: current_state == 10 }" @click="changeState(10)">未入账</div>
          <div :class="{ item: true, active: current_state == 40 }" @click="changeState(40)">已还款</div>
          <div :class="{ item: true, active: current_state == 20 }" @click="changeState(20)">待还款</div>
          <div :class="{ item: true, active: current_state == 30 }" @click="changeState(30)">
            待审核
          </div>
          <div :class="{ item: true, active: current_state == 50 }" @click="changeState(50)">已逾期</div>
        </div>
        <div class="dao_btn flex_row_center_center" @click="downLoad">
          导出
        </div>
      </div>
      <div class="after_sales_title">
        <div class="search_con flex_row_start_center">
          <div class="search_incon flex_row_start_center">
            <el-input class="search_input" v-model="billOrderSn" placeholder="客户名称/单位名称" clearable @clear="clear">
            </el-input>
            <div class="search pointer" @click="getOrderList">
              {{ L["搜索"] }}
            </div>
          </div>
        </div>
        <!-- <div class="search_out pointer">导出全部账单</div> -->
      </div>
      <div class="after_sales_list">
        <div class="after_sales_list_con">
          <el-table :data="afterSalesList.data" style="width: 100%" empty-text="暂无数据">
            <el-table-column prop="billSn" align="center" label="信用单号" width="" />
            <el-table-column prop="companyName" align="center" label="客户名称" width="" />
            <el-table-column prop="companyName" align="center" label="单位全称" />
            <el-table-column prop="orderSn" align="center" label="订单号" />
            <el-table-column prop="amount" align="center" label="订单金额" />
            <el-table-column prop="createTime" align="center" label="下单时间" />
            <el-table-column prop="lastRepayDate" align="center" label="最后还款日" />
            <el-table-column prop="billStateValue" align="center" label="账单状态" />
          </el-table>
          <SldCommonEmpty v-show="!afterSalesList.data.length" totalWidth="900"></SldCommonEmpty>
          <div class="flex_row_end_center sld_pagination sld_page_bottom" v-if="
            aftersalesDetail.data &&
            aftersalesDetail.data.pagination &&
            aftersalesDetail.data.pagination.total
          ">
            <el-pagination @current-change="handleCurrentChange" v-model:currentPage="current" :page-size="pageSize"
              layout="prev, pager, next, jumper" :total="aftersalesDetail.data.pagination.total"
              :hide-on-single-page="true">
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { useStore } from "vuex";
import axios from 'axios'
import { apiUrl } from '../../../utils/config'
import { getLocalStorageStr, format } from '../../../utils/common'
import { onMounted, reactive, ref, getCurrentInstance, watchEffect } from "vue";
import { ElMessage, ElPagination, ElLoading } from "element-plus";
import SldCommonEmpty from "../../../components/SldCommonEmpty";
import { useRouter, useRoute } from "vue-router";
import MemberTitle from "../../../components/MemberTitles";

export default {
  components: {
    ElPagination,
    MemberTitle,
    SldCommonEmpty,
  },
  setup() {
    const { proxy } = getCurrentInstance();
    const L = proxy.$getCurLanguage();
    const router = useRouter();
    const route = useRoute();
    const curTitleId = ref(1); //当前选中的标题id
    const afterSalesList = reactive({ data: [] }); //售后列表
    const current_state = ref(""); //当前列表订单状态
    const pageSize = ref(10);
    const current = ref(1);
    const aftersalesDetail = reactive({ data: {} }); //售后列表详情数据

    const orderSn = ref('')

    const billOrderSn = ref('')
    const billState = ref('')
    const store = useStore();

    const toStore = (storeId) => {
      if (storeId == 0) {
        return;
      }
      proxy.$goStoreDetail(storeId);
    };

    const getOrderList = () => {
      getAfterSalesDet()
    }

    onMounted(() => {
      if (route.query.orderState) {
        current_state.value = route.query.orderState;
      } else {
        current_state.value = "";
      }
      // 非销售员 登录进来之后跳转首页
      if (store.state.memberInfo.isSale == 0) {
        router.push({ path: "/index" });
      }
      getAfterSalesDet();
    });
    //   router.beforeEach((to, from, next) => {
    //     if (to.query.type == "return") {
    //       curTitleId.value = 2; //退款退货
    //     } else {
    //       curTitleId.value = 1; //仅退款
    //     }
    //     getAfterSalesDet();
    //     next();
    //   });
    //获取列表
    const getAfterSalesDet = () => {
      let memberInfo = JSON.parse(localStorage.getItem('memberInfo'))
      let params = {
        memberNameOrCompanyName: billOrderSn.value,
        billState: billState.value,
        current: current.value,
        pageSize: pageSize.value,
        memberId:memberInfo.memberId
      };
      proxy.$get("v3/member/front/creditBill/billList", params).then((res) => {
        if (res.state == 200) {
          let result = res.data.list;
          console.log(result, 'result')
          aftersalesDetail.data = res.data;
          afterSalesList.data = result
          // afterSalesList.data = [
          //   {
          //     applyTime: "5000000001",
          //     returnTypeValue: "张三",
          //     stateValue: "上海市xxxxxxxxxxx公司",
          //     stateValue1: "5000000001",
          //     stateValue2: "100.00",
          //     stateValue3: "2022-01-01",
          //     stateValue4: "2022-02-01",
          //     stateValue5: "已还款",
          //   },
          //   {
          //     applyTime: "5000000001",
          //     returnTypeValue: "张三",
          //     stateValue: "上海市xx公司",
          //     stateValue1: "5000000001",
          //     stateValue2: "100.00",
          //     stateValue3: "2022-01-01",
          //     stateValue4: "2022-02-01",
          //     stateValue5: "已还款",
          //   },
          // ]; //result.list;
        } else {
          ElMessage.error(res.msg);
        }
      });
    };

    // 导出
    const downLoad = () => {
      const loading = ElLoading.service({
        lock: true,
        text: 'Loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      let memberInfo = JSON.parse(localStorage.getItem('memberInfo'))
      let params = {
        memberNameOrCompanyName: billOrderSn.value,
        billState: billState.value,
        memberId: memberInfo.memberId
      };
      // console.log(format(new Date(Date.now()),'yyyy-MM-dd-hh-mm-ss'))
      let token = getLocalStorageStr('access_token');
      axios({
        method: 'GET',
        url: apiUrl + 'v3/member/front/creditBill/export',
        params: { ...params },
        responseType: 'blob',
        headers: {
          Authorization: 'Bearer ' + token
        }
      }).then(res => {
        if (res.data.type != 'application/json') {
            loading.close()
          // 将文档流转换为二进制数据
          const blob = new Blob([res.data], { type: res.data.type || 'application/vnd.ms-excel' });
          // 创建一个 URL 对象，指向二进制数据
          const url = URL.createObjectURL(blob);

          // 创建一个下载链接并单击它来下载文件
          const link = document.createElement('a');
          link.href = url;
          link.download = `客户账单${format(new Date(Date.now()), 'yyyy-MM-dd-hh-mm-ss')}.xls`;
          document.body.appendChild(link);
          link.click();

          // 释放 URL 对象
          URL.revokeObjectURL(url);   
          document.body.removeChild(link); // 释放标签
          ElMessage.success('导出成功');
        } else {
            loading.close()
          ElMessage.error('导出失败');
        }
      })

    }
    //选择类型
    const titleNav = (titleId) => {
      curTitleId.value = titleId;
      getAfterSalesDet();
    };
    //上一页
    const handlePrevCilickChange = () => {
      current.value--;
      getAfterSalesDet();
    };
    //下一页
    const handleNextCilickChange = () => {
      current.value++;
      getAfterSalesDet();
    };
    //选择页面
    const handleCurrentChange = () => {
      getAfterSalesDet();
    };
    //申请授信
    const goRefundDetail = (url) => {
      router.push({
        path: url,
      });
    };
    //填写物流单号
    const logisticsBill = (afterSalesItem) => {
      router.push({
        path: "/member/order/logistics",
        query: {
          afsSn: afterSalesItem.afsSn,
        },
      });
    };
    //去商品详情页
    const goGoodsDetail = (productId) => {
      proxy.$goGoodsDetail(productId);
    };
    //改变订单状态
    const changeState = (orderState) => {
      billState.value = orderState
      current_state.value = orderState
      current.value = 1
      getAfterSalesDet()
    };

    return {
      L,
      curTitleId,
      afterSalesList,
      titleNav,
      pageSize,
      current,
      aftersalesDetail,
      handlePrevCilickChange,
      handleNextCilickChange,
      handleCurrentChange,
      goRefundDetail,
      logisticsBill,
      goGoodsDetail,
      toStore,
      current_state,
      changeState,
      billOrderSn,
      billState,
      getOrderList,
      orderSn,
      downLoad,
      store,
    };
  },
};
</script>
<style lang="scss" scoped>
@import "../../../style/base.scss";
@import "../../../style/iconfont.css";

.storeName {
  color: #333;

  &:hover {
    color: $colorMain;
  }
}

.search_con {
  height: 44px;
  padding-top: 18px;
  padding-bottom: 18px;
  box-sizing: border-box;

  .search_incon {
    width: 321px;
    height: 34px;
    background: #ffffff;
    border: 1px solid #e8e8f1;
  }

  .search_input {
    width: 323px;
    border-right: none;
  }

  .el-input__inner {
    height: 29px;
    padding-left: 11px;
    border: none;
    box-sizing: border-box;
    outline: none;
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 400;
  }

  .search {
    width: 70px;
    height: 40px;
    border: none;
    background-color: #f7f7f7;
    color: #000;
    line-height: 40px;
    text-align: center;
    font-size: 12px;
  }

  .el-select {
    height: 34px;
    line-height: 34px;
    box-shadow: 0 0 3px 2px #f5f5f5;

    .el-input {
      width: 150px;
      height: 34px;
    }

    .el-input__inner {
      position: absolute;
      top: 0;
      left: 0;
      height: 34px;
      padding-left: 10px;
      padding-right: 10px;
      border: none;
      box-sizing: border-box;
      outline: none;
    }

    .el-input__suffix {
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}

.search_out {
  // width: 70px;
  padding: 0 5px;
  height: 40px;
  border: none;
  background-color: #f7f7f7;
  color: #000;
  line-height: 40px;
  text-align: center;
  font-size: 12px;
}
</style>
<style lang="scss">
@import "../../../style/connection_bill.scss";

.sld_after_connection_bill {
  tr {
    th {
      background-color: #F5F5F5;
      color: #000;
    }
  }
}
</style>